module.exports = __webpack_public_path__ + "static/media/sidebarbgr.90f02e63.jpg";